export const LS_LANG = 'lang';